export default "__VITE_ASSET__D1qWO7JX__"